<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">
  
      <section id="header">
        <h1 class="h1Header">GESTIÓN DE EXTRAS</h1>
      </section>
  
      <mat-card class="mat-elevation-z0">
        <div>
          <button mat-raised-button class="add-btn" (click)="addExtra()">Agregar Nuevo</button>
        </div>
        <table mat-table [dataSource]="allAddons">
  
          <!-- Name Column -->
          <ng-container matColumnDef="titulo">
            <th mat-header-cell *matHeaderCellDef class="table-header">TÍTULO</th>
            <td mat-cell *matCellDef="let element" class="table-content"> {{element.dsName}}</td>
          </ng-container>
  
          <!-- Tel Column -->
          <ng-container matColumnDef="precio">
            <th mat-header-cell *matHeaderCellDef class="table-header"> PRECIO</th>
            <td mat-cell *matCellDef="let element" class="table-content"> {{element.qtPrice}} </td>
          </ng-container>
  
          <!-- Options Column -->
  
          <ng-container matColumnDef="opcion">
            <th mat-header-cell *matHeaderCellDef class="table-header">OPCIÓN</th>
            <td mat-cell *matCellDef="let element" class="table-content">
                <button mat-mini-fab class="edit-btn" (click)="editExtra(element.cdAddon)"
                matTooltip="Editar extra"><mat-icon>create</mat-icon>
                </button>
                <button mat-mini-fab class="delete-btn" (click)="deleteExtra(element.cdAddon)"
                matTooltip="Eliminar extra"><mat-icon>delete</mat-icon>
                </button>
            </td>
          </ng-container>
  
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
        </table>
      </mat-card>
    </div>
</div>
